export const defaultPaginationsData = [
  {
    text: "You can set pagination using ",
    code: 'aria-label="Search results pages"',
  },
];

export const activeDisablePaginationsData = [
  {
    text: "for links that appear un-clickable and  ",
    code: ".disabled , .active ",
  },
  {
    text: "to indicate the current page."
  }
];

export const iconPaginationData = [
  {
    text: "Use an icon or symbol in place of text for some pagination links.",
  },
];

export const roundedPaginationData = [
  {
    text: "Used in rounded pagination.Use an icon or symbol in place of text for some pagination links.",
    code: "[.rounded-circle]",
  },
];

export const alignmentPaginationData = [
  {
    text: "Change the alignment of pagination components with flexbox utilities. For example, with ",
    code: ".justify-content-center:.",
  },
];

export const alignmentDataList = [
  {
    className: "justify-content-center m-b-30",
    active: true,
    color: "secondary",
    smallText: true,
  },
  {
    className: "justify-content-end",
    color: "success",
  },
];

export const sizingPaginationData = [
  {
    text: "Use ",
    code: "[pagination-lg/pagination-md/pagination-lg]",
  },
  {
    text: " for additional sizes.",
  },
];

export const sizingPaginationDataList = [
  {
    className: "m-b-30",
    size: "md",
  },
  {
    size: "sm",
  },
];
export const nextData = ["1", "2", "...", "20"];